import { render, staticRenderFns } from "./docMarkdown.vue?vue&type=template&id=6dd8ebca&scoped=true"
import script from "./docMarkdown.vue?vue&type=script&lang=ts"
export * from "./docMarkdown.vue?vue&type=script&lang=ts"
import style0 from "./docMarkdown.vue?vue&type=style&index=0&id=6dd8ebca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd8ebca",
  null
  
)

export default component.exports